import React from 'react'

import ClientBudgets from '../../../../components/Project/Resources/ClientBudgets/ClientBudgets'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { ClientBudgetsApi } from '../../../../api/Corporates/Projects'
import useSelectionTable from '../../../../elements/Hooks/useSelectionTable'
import useModalData from '../../../../elements/Hooks/useModalData'
import { message } from 'antd'
import { pick } from 'lodash'

function ClientBudgetsCont (props) {
  const { project } = props
  const { list, fetching, fetch } = useFetchList(() => ClientBudgetsApi.list(project._key))
  const { tableRef, selection, selectAll, setSelection, toggleSelection, toggleAll, isSelected } = useSelectionTable()

  const {
    visible,
    modalType,
    object: clientBudget,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
  } = useModalData(ClientBudgetsApi.create, ClientBudgetsApi.update, ClientBudgetsApi.remove, fetch)

  async function submit () {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await ClientBudgetsApi.create(project._key, { ...newObject, project })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  async function update () {
    const updatedObject = await checkForm()
    setSubmitting(true)
    try {
      await ClientBudgetsApi.update(project._key, {
        ...updatedObject,
        ...pick(clientBudget, ['_id', '_rev']),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <ClientBudgets
      {...{
        list,
        project,
        fetching,
        submitting,
        removing,
        visible,
        fetch,
        clientBudget,
        onShow,
        onCancel,
        checkForm,
        submit,
        update,
        remove,
        modalType,
        formRef,
        //selection
        selection,
        selectAll,
        setSelection,
        tableRef,
        toggleSelection,
        toggleAll,
        isSelected,
      }}
    />
  )
}

ClientBudgetsCont.propTypes = {}
ClientBudgetsCont.defaultProps = {}

export default (ClientBudgetsCont)
